<div class="spinner">
    <mat-spinner #spinner></mat-spinner>
</div>

